/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as CompetenceRouteRouteImport } from './routes/competence/route'
import { Route as CultivationRouteRouteImport } from './routes/cultivation/route'
import { Route as CustomerRouteRouteImport } from './routes/customer/route'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DisposalRouteRouteImport } from './routes/disposal/route'
import { Route as ElisaRouteRouteImport } from './routes/elisa/route'
import { Route as EmailRouteImport } from './routes/email'
import { Route as FeedRouteRouteImport } from './routes/feed/route'
import { Route as InvoiceRouteRouteImport } from './routes/invoice/route'
import { Route as LineCheckRouteImport } from './routes/lineCheck'
import { Route as LungmaskRouteRouteImport } from './routes/lungmask/route'
import { Route as PcrRouteRouteImport } from './routes/pcr/route'
import { Route as QuickRegistrationRouteImport } from './routes/quickRegistration'
import { Route as ReadRouteImport } from './routes/read'
import { Route as RegistrationRouteImport } from './routes/registration'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as ResultsTableRouteImport } from './routes/resultsTable'
import { Route as StatisticsRouteRouteImport } from './routes/statistics/route'
import { Route as TodoRouteImport } from './routes/todo'
import { Route as TrikinRouteRouteImport } from './routes/trikin/route'
import { Route as UnfinishedRouteImport } from './routes/unfinished'
import { Route as UsersRouteImport } from './routes/users'
import { Route as AdminArticlesRouteImport } from './routes/admin/articles'
import { Route as AdminMaintenanceRouteImport } from './routes/admin/maintenance'
import { Route as AdminMethodViewerRouteImport } from './routes/admin/methodViewer'
import { Route as AdminProductViewerRouteImport } from './routes/admin/productViewer'
import { Route as CompetenceCompetencesRouteImport } from './routes/competence/competences'
import { Route as CompetenceEditRolesRouteImport } from './routes/competence/editRoles'
import { Route as CompetenceExaminationRouteImport } from './routes/competence/examination'
import { Route as CompetenceGeneralRouteImport } from './routes/competence/general'
import { Route as CompetenceMyExaminationRouteImport } from './routes/competence/myExamination'
import { Route as CultivationFetchRouteImport } from './routes/cultivation/fetch'
import { Route as CultivationStartRouteImport } from './routes/cultivation/start'
import { Route as CustomerCustomersRouteImport } from './routes/customer/customers'
import { Route as CustomerDuplicatesRouteImport } from './routes/customer/duplicates'
import { Route as DisposalCheckRouteImport } from './routes/disposal/check'
import { Route as DisposalDisposeRouteImport } from './routes/disposal/dispose'
import { Route as ElisaCheckRouteImport } from './routes/elisa/check'
import { Route as ElisaMapplatesRouteImport } from './routes/elisa/mapplates'
import { Route as ElisaStatusRouteImport } from './routes/elisa/status'
import { Route as ElisaUploadRouteImport } from './routes/elisa/upload'
import { Route as FeedCheckRouteImport } from './routes/feed/check'
import { Route as FeedListsRouteImport } from './routes/feed/lists'
import { Route as FeedReadRouteImport } from './routes/feed/read'
import { Route as FeedSendRouteImport } from './routes/feed/send'
import { Route as FeedUploadRouteImport } from './routes/feed/upload'
import { Route as FeedVallprognosRouteImport } from './routes/feed/vallprognos'
import { Route as InvoiceInvoiceRouteImport } from './routes/invoice/invoice'
import { Route as InvoiceInvoiceGodRouteImport } from './routes/invoice/invoiceGod'
import { Route as LungmaskFetchRouteImport } from './routes/lungmask/fetch'
import { Route as LungmaskStartRouteImport } from './routes/lungmask/start'
import { Route as PcrCheckRouteImport } from './routes/pcr/check'
import { Route as PcrMapplatesRouteImport } from './routes/pcr/mapplates'
import { Route as PcrPipetteRouteImport } from './routes/pcr/pipette'
import { Route as PcrPrepareRouteImport } from './routes/pcr/prepare'
import { Route as PcrStatusRouteImport } from './routes/pcr/status'
import { Route as PcrUploadRouteImport } from './routes/pcr/upload'
import { Route as RegistrationJournalIdRouteImport } from './routes/registration.$journalId'
import { Route as StatisticsDayStatisticsRouteImport } from './routes/statistics/dayStatistics'
import { Route as StatisticsStatisticsRouteImport } from './routes/statistics/statistics'
import { Route as TrikinBubbleRouteImport } from './routes/trikin/bubble'
import { Route as TrikinNotesRouteImport } from './routes/trikin/notes'
import { Route as TrikinReadRouteImport } from './routes/trikin/read'

const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetenceRouteRoute = CompetenceRouteRouteImport.update({
  id: '/competence',
  path: '/competence',
  getParentRoute: () => rootRouteImport,
} as any)
const CultivationRouteRoute = CultivationRouteRouteImport.update({
  id: '/cultivation',
  path: '/cultivation',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerRouteRoute = CustomerRouteRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DisposalRouteRoute = DisposalRouteRouteImport.update({
  id: '/disposal',
  path: '/disposal',
  getParentRoute: () => rootRouteImport,
} as any)
const ElisaRouteRoute = ElisaRouteRouteImport.update({
  id: '/elisa',
  path: '/elisa',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailRoute = EmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedRouteRoute = FeedRouteRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoiceRouteRoute = InvoiceRouteRouteImport.update({
  id: '/invoice',
  path: '/invoice',
  getParentRoute: () => rootRouteImport,
} as any)
const LineCheckRoute = LineCheckRouteImport.update({
  id: '/lineCheck',
  path: '/lineCheck',
  getParentRoute: () => rootRouteImport,
} as any)
const LungmaskRouteRoute = LungmaskRouteRouteImport.update({
  id: '/lungmask',
  path: '/lungmask',
  getParentRoute: () => rootRouteImport,
} as any)
const PcrRouteRoute = PcrRouteRouteImport.update({
  id: '/pcr',
  path: '/pcr',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickRegistrationRoute = QuickRegistrationRouteImport.update({
  id: '/quickRegistration',
  path: '/quickRegistration',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadRoute = ReadRouteImport.update({
  id: '/read',
  path: '/read',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrationRoute = RegistrationRouteImport.update({
  id: '/registration',
  path: '/registration',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsTableRoute = ResultsTableRouteImport.update({
  id: '/resultsTable',
  path: '/resultsTable',
  getParentRoute: () => rootRouteImport,
} as any)
const StatisticsRouteRoute = StatisticsRouteRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => rootRouteImport,
} as any)
const TodoRoute = TodoRouteImport.update({
  id: '/todo',
  path: '/todo',
  getParentRoute: () => rootRouteImport,
} as any)
const TrikinRouteRoute = TrikinRouteRouteImport.update({
  id: '/trikin',
  path: '/trikin',
  getParentRoute: () => rootRouteImport,
} as any)
const UnfinishedRoute = UnfinishedRouteImport.update({
  id: '/unfinished',
  path: '/unfinished',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminArticlesRoute = AdminArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMaintenanceRoute = AdminMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMethodViewerRoute = AdminMethodViewerRouteImport.update({
  id: '/methodViewer',
  path: '/methodViewer',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProductViewerRoute = AdminProductViewerRouteImport.update({
  id: '/productViewer',
  path: '/productViewer',
  getParentRoute: () => AdminRouteRoute,
} as any)
const CompetenceCompetencesRoute = CompetenceCompetencesRouteImport.update({
  id: '/competences',
  path: '/competences',
  getParentRoute: () => CompetenceRouteRoute,
} as any)
const CompetenceEditRolesRoute = CompetenceEditRolesRouteImport.update({
  id: '/editRoles',
  path: '/editRoles',
  getParentRoute: () => CompetenceRouteRoute,
} as any)
const CompetenceExaminationRoute = CompetenceExaminationRouteImport.update({
  id: '/examination',
  path: '/examination',
  getParentRoute: () => CompetenceRouteRoute,
} as any)
const CompetenceGeneralRoute = CompetenceGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => CompetenceRouteRoute,
} as any)
const CompetenceMyExaminationRoute = CompetenceMyExaminationRouteImport.update({
  id: '/myExamination',
  path: '/myExamination',
  getParentRoute: () => CompetenceRouteRoute,
} as any)
const CultivationFetchRoute = CultivationFetchRouteImport.update({
  id: '/fetch',
  path: '/fetch',
  getParentRoute: () => CultivationRouteRoute,
} as any)
const CultivationStartRoute = CultivationStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => CultivationRouteRoute,
} as any)
const CustomerCustomersRoute = CustomerCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const CustomerDuplicatesRoute = CustomerDuplicatesRouteImport.update({
  id: '/duplicates',
  path: '/duplicates',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const DisposalCheckRoute = DisposalCheckRouteImport.update({
  id: '/check',
  path: '/check',
  getParentRoute: () => DisposalRouteRoute,
} as any)
const DisposalDisposeRoute = DisposalDisposeRouteImport.update({
  id: '/dispose',
  path: '/dispose',
  getParentRoute: () => DisposalRouteRoute,
} as any)
const ElisaCheckRoute = ElisaCheckRouteImport.update({
  id: '/check',
  path: '/check',
  getParentRoute: () => ElisaRouteRoute,
} as any)
const ElisaMapplatesRoute = ElisaMapplatesRouteImport.update({
  id: '/mapplates',
  path: '/mapplates',
  getParentRoute: () => ElisaRouteRoute,
} as any)
const ElisaStatusRoute = ElisaStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => ElisaRouteRoute,
} as any)
const ElisaUploadRoute = ElisaUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => ElisaRouteRoute,
} as any)
const FeedCheckRoute = FeedCheckRouteImport.update({
  id: '/check',
  path: '/check',
  getParentRoute: () => FeedRouteRoute,
} as any)
const FeedListsRoute = FeedListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => FeedRouteRoute,
} as any)
const FeedReadRoute = FeedReadRouteImport.update({
  id: '/read',
  path: '/read',
  getParentRoute: () => FeedRouteRoute,
} as any)
const FeedSendRoute = FeedSendRouteImport.update({
  id: '/send',
  path: '/send',
  getParentRoute: () => FeedRouteRoute,
} as any)
const FeedUploadRoute = FeedUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => FeedRouteRoute,
} as any)
const FeedVallprognosRoute = FeedVallprognosRouteImport.update({
  id: '/vallprognos',
  path: '/vallprognos',
  getParentRoute: () => FeedRouteRoute,
} as any)
const InvoiceInvoiceRoute = InvoiceInvoiceRouteImport.update({
  id: '/invoice',
  path: '/invoice',
  getParentRoute: () => InvoiceRouteRoute,
} as any)
const InvoiceInvoiceGodRoute = InvoiceInvoiceGodRouteImport.update({
  id: '/invoiceGod',
  path: '/invoiceGod',
  getParentRoute: () => InvoiceRouteRoute,
} as any)
const LungmaskFetchRoute = LungmaskFetchRouteImport.update({
  id: '/fetch',
  path: '/fetch',
  getParentRoute: () => LungmaskRouteRoute,
} as any)
const LungmaskStartRoute = LungmaskStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => LungmaskRouteRoute,
} as any)
const PcrCheckRoute = PcrCheckRouteImport.update({
  id: '/check',
  path: '/check',
  getParentRoute: () => PcrRouteRoute,
} as any)
const PcrMapplatesRoute = PcrMapplatesRouteImport.update({
  id: '/mapplates',
  path: '/mapplates',
  getParentRoute: () => PcrRouteRoute,
} as any)
const PcrPipetteRoute = PcrPipetteRouteImport.update({
  id: '/pipette',
  path: '/pipette',
  getParentRoute: () => PcrRouteRoute,
} as any)
const PcrPrepareRoute = PcrPrepareRouteImport.update({
  id: '/prepare',
  path: '/prepare',
  getParentRoute: () => PcrRouteRoute,
} as any)
const PcrStatusRoute = PcrStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => PcrRouteRoute,
} as any)
const PcrUploadRoute = PcrUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => PcrRouteRoute,
} as any)
const RegistrationJournalIdRoute = RegistrationJournalIdRouteImport.update({
  id: '/$journalId',
  path: '/$journalId',
  getParentRoute: () => RegistrationRoute,
} as any)
const StatisticsDayStatisticsRoute = StatisticsDayStatisticsRouteImport.update({
  id: '/dayStatistics',
  path: '/dayStatistics',
  getParentRoute: () => StatisticsRouteRoute,
} as any)
const StatisticsStatisticsRoute = StatisticsStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => StatisticsRouteRoute,
} as any)
const TrikinBubbleRoute = TrikinBubbleRouteImport.update({
  id: '/bubble',
  path: '/bubble',
  getParentRoute: () => TrikinRouteRoute,
} as any)
const TrikinNotesRoute = TrikinNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => TrikinRouteRoute,
} as any)
const TrikinReadRoute = TrikinReadRouteImport.update({
  id: '/read',
  path: '/read',
  getParentRoute: () => TrikinRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteRouteWithChildren
  '/competence': typeof CompetenceRouteRouteWithChildren
  '/cultivation': typeof CultivationRouteRouteWithChildren
  '/customer': typeof CustomerRouteRouteWithChildren
  '/disposal': typeof DisposalRouteRouteWithChildren
  '/elisa': typeof ElisaRouteRouteWithChildren
  '/feed': typeof FeedRouteRouteWithChildren
  '/invoice': typeof InvoiceRouteRouteWithChildren
  '/lungmask': typeof LungmaskRouteRouteWithChildren
  '/pcr': typeof PcrRouteRouteWithChildren
  '/statistics': typeof StatisticsRouteRouteWithChildren
  '/trikin': typeof TrikinRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/email': typeof EmailRoute
  '/lineCheck': typeof LineCheckRoute
  '/quickRegistration': typeof QuickRegistrationRoute
  '/read': typeof ReadRoute
  '/registration': typeof RegistrationRouteWithChildren
  '/results': typeof ResultsRoute
  '/resultsTable': typeof ResultsTableRoute
  '/todo': typeof TodoRoute
  '/unfinished': typeof UnfinishedRoute
  '/users': typeof UsersRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/admin/maintenance': typeof AdminMaintenanceRoute
  '/admin/methodViewer': typeof AdminMethodViewerRoute
  '/admin/productViewer': typeof AdminProductViewerRoute
  '/competence/competences': typeof CompetenceCompetencesRoute
  '/competence/editRoles': typeof CompetenceEditRolesRoute
  '/competence/examination': typeof CompetenceExaminationRoute
  '/competence/general': typeof CompetenceGeneralRoute
  '/competence/myExamination': typeof CompetenceMyExaminationRoute
  '/cultivation/fetch': typeof CultivationFetchRoute
  '/cultivation/start': typeof CultivationStartRoute
  '/customer/customers': typeof CustomerCustomersRoute
  '/customer/duplicates': typeof CustomerDuplicatesRoute
  '/disposal/check': typeof DisposalCheckRoute
  '/disposal/dispose': typeof DisposalDisposeRoute
  '/elisa/check': typeof ElisaCheckRoute
  '/elisa/mapplates': typeof ElisaMapplatesRoute
  '/elisa/status': typeof ElisaStatusRoute
  '/elisa/upload': typeof ElisaUploadRoute
  '/feed/check': typeof FeedCheckRoute
  '/feed/lists': typeof FeedListsRoute
  '/feed/read': typeof FeedReadRoute
  '/feed/send': typeof FeedSendRoute
  '/feed/upload': typeof FeedUploadRoute
  '/feed/vallprognos': typeof FeedVallprognosRoute
  '/invoice/invoice': typeof InvoiceInvoiceRoute
  '/invoice/invoiceGod': typeof InvoiceInvoiceGodRoute
  '/lungmask/fetch': typeof LungmaskFetchRoute
  '/lungmask/start': typeof LungmaskStartRoute
  '/pcr/check': typeof PcrCheckRoute
  '/pcr/mapplates': typeof PcrMapplatesRoute
  '/pcr/pipette': typeof PcrPipetteRoute
  '/pcr/prepare': typeof PcrPrepareRoute
  '/pcr/status': typeof PcrStatusRoute
  '/pcr/upload': typeof PcrUploadRoute
  '/registration/$journalId': typeof RegistrationJournalIdRoute
  '/statistics/dayStatistics': typeof StatisticsDayStatisticsRoute
  '/statistics/statistics': typeof StatisticsStatisticsRoute
  '/trikin/bubble': typeof TrikinBubbleRoute
  '/trikin/notes': typeof TrikinNotesRoute
  '/trikin/read': typeof TrikinReadRoute
}
export interface FileRoutesByTo {
  '/admin': typeof AdminRouteRouteWithChildren
  '/competence': typeof CompetenceRouteRouteWithChildren
  '/cultivation': typeof CultivationRouteRouteWithChildren
  '/customer': typeof CustomerRouteRouteWithChildren
  '/disposal': typeof DisposalRouteRouteWithChildren
  '/elisa': typeof ElisaRouteRouteWithChildren
  '/feed': typeof FeedRouteRouteWithChildren
  '/invoice': typeof InvoiceRouteRouteWithChildren
  '/lungmask': typeof LungmaskRouteRouteWithChildren
  '/pcr': typeof PcrRouteRouteWithChildren
  '/statistics': typeof StatisticsRouteRouteWithChildren
  '/trikin': typeof TrikinRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/email': typeof EmailRoute
  '/lineCheck': typeof LineCheckRoute
  '/quickRegistration': typeof QuickRegistrationRoute
  '/read': typeof ReadRoute
  '/registration': typeof RegistrationRouteWithChildren
  '/results': typeof ResultsRoute
  '/resultsTable': typeof ResultsTableRoute
  '/todo': typeof TodoRoute
  '/unfinished': typeof UnfinishedRoute
  '/users': typeof UsersRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/admin/maintenance': typeof AdminMaintenanceRoute
  '/admin/methodViewer': typeof AdminMethodViewerRoute
  '/admin/productViewer': typeof AdminProductViewerRoute
  '/competence/competences': typeof CompetenceCompetencesRoute
  '/competence/editRoles': typeof CompetenceEditRolesRoute
  '/competence/examination': typeof CompetenceExaminationRoute
  '/competence/general': typeof CompetenceGeneralRoute
  '/competence/myExamination': typeof CompetenceMyExaminationRoute
  '/cultivation/fetch': typeof CultivationFetchRoute
  '/cultivation/start': typeof CultivationStartRoute
  '/customer/customers': typeof CustomerCustomersRoute
  '/customer/duplicates': typeof CustomerDuplicatesRoute
  '/disposal/check': typeof DisposalCheckRoute
  '/disposal/dispose': typeof DisposalDisposeRoute
  '/elisa/check': typeof ElisaCheckRoute
  '/elisa/mapplates': typeof ElisaMapplatesRoute
  '/elisa/status': typeof ElisaStatusRoute
  '/elisa/upload': typeof ElisaUploadRoute
  '/feed/check': typeof FeedCheckRoute
  '/feed/lists': typeof FeedListsRoute
  '/feed/read': typeof FeedReadRoute
  '/feed/send': typeof FeedSendRoute
  '/feed/upload': typeof FeedUploadRoute
  '/feed/vallprognos': typeof FeedVallprognosRoute
  '/invoice/invoice': typeof InvoiceInvoiceRoute
  '/invoice/invoiceGod': typeof InvoiceInvoiceGodRoute
  '/lungmask/fetch': typeof LungmaskFetchRoute
  '/lungmask/start': typeof LungmaskStartRoute
  '/pcr/check': typeof PcrCheckRoute
  '/pcr/mapplates': typeof PcrMapplatesRoute
  '/pcr/pipette': typeof PcrPipetteRoute
  '/pcr/prepare': typeof PcrPrepareRoute
  '/pcr/status': typeof PcrStatusRoute
  '/pcr/upload': typeof PcrUploadRoute
  '/registration/$journalId': typeof RegistrationJournalIdRoute
  '/statistics/dayStatistics': typeof StatisticsDayStatisticsRoute
  '/statistics/statistics': typeof StatisticsStatisticsRoute
  '/trikin/bubble': typeof TrikinBubbleRoute
  '/trikin/notes': typeof TrikinNotesRoute
  '/trikin/read': typeof TrikinReadRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/admin': typeof AdminRouteRouteWithChildren
  '/competence': typeof CompetenceRouteRouteWithChildren
  '/cultivation': typeof CultivationRouteRouteWithChildren
  '/customer': typeof CustomerRouteRouteWithChildren
  '/disposal': typeof DisposalRouteRouteWithChildren
  '/elisa': typeof ElisaRouteRouteWithChildren
  '/feed': typeof FeedRouteRouteWithChildren
  '/invoice': typeof InvoiceRouteRouteWithChildren
  '/lungmask': typeof LungmaskRouteRouteWithChildren
  '/pcr': typeof PcrRouteRouteWithChildren
  '/statistics': typeof StatisticsRouteRouteWithChildren
  '/trikin': typeof TrikinRouteRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/email': typeof EmailRoute
  '/lineCheck': typeof LineCheckRoute
  '/quickRegistration': typeof QuickRegistrationRoute
  '/read': typeof ReadRoute
  '/registration': typeof RegistrationRouteWithChildren
  '/results': typeof ResultsRoute
  '/resultsTable': typeof ResultsTableRoute
  '/todo': typeof TodoRoute
  '/unfinished': typeof UnfinishedRoute
  '/users': typeof UsersRoute
  '/admin/articles': typeof AdminArticlesRoute
  '/admin/maintenance': typeof AdminMaintenanceRoute
  '/admin/methodViewer': typeof AdminMethodViewerRoute
  '/admin/productViewer': typeof AdminProductViewerRoute
  '/competence/competences': typeof CompetenceCompetencesRoute
  '/competence/editRoles': typeof CompetenceEditRolesRoute
  '/competence/examination': typeof CompetenceExaminationRoute
  '/competence/general': typeof CompetenceGeneralRoute
  '/competence/myExamination': typeof CompetenceMyExaminationRoute
  '/cultivation/fetch': typeof CultivationFetchRoute
  '/cultivation/start': typeof CultivationStartRoute
  '/customer/customers': typeof CustomerCustomersRoute
  '/customer/duplicates': typeof CustomerDuplicatesRoute
  '/disposal/check': typeof DisposalCheckRoute
  '/disposal/dispose': typeof DisposalDisposeRoute
  '/elisa/check': typeof ElisaCheckRoute
  '/elisa/mapplates': typeof ElisaMapplatesRoute
  '/elisa/status': typeof ElisaStatusRoute
  '/elisa/upload': typeof ElisaUploadRoute
  '/feed/check': typeof FeedCheckRoute
  '/feed/lists': typeof FeedListsRoute
  '/feed/read': typeof FeedReadRoute
  '/feed/send': typeof FeedSendRoute
  '/feed/upload': typeof FeedUploadRoute
  '/feed/vallprognos': typeof FeedVallprognosRoute
  '/invoice/invoice': typeof InvoiceInvoiceRoute
  '/invoice/invoiceGod': typeof InvoiceInvoiceGodRoute
  '/lungmask/fetch': typeof LungmaskFetchRoute
  '/lungmask/start': typeof LungmaskStartRoute
  '/pcr/check': typeof PcrCheckRoute
  '/pcr/mapplates': typeof PcrMapplatesRoute
  '/pcr/pipette': typeof PcrPipetteRoute
  '/pcr/prepare': typeof PcrPrepareRoute
  '/pcr/status': typeof PcrStatusRoute
  '/pcr/upload': typeof PcrUploadRoute
  '/registration/$journalId': typeof RegistrationJournalIdRoute
  '/statistics/dayStatistics': typeof StatisticsDayStatisticsRoute
  '/statistics/statistics': typeof StatisticsStatisticsRoute
  '/trikin/bubble': typeof TrikinBubbleRoute
  '/trikin/notes': typeof TrikinNotesRoute
  '/trikin/read': typeof TrikinReadRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/competence'
    | '/cultivation'
    | '/customer'
    | '/disposal'
    | '/elisa'
    | '/feed'
    | '/invoice'
    | '/lungmask'
    | '/pcr'
    | '/statistics'
    | '/trikin'
    | '/dashboard'
    | '/email'
    | '/lineCheck'
    | '/quickRegistration'
    | '/read'
    | '/registration'
    | '/results'
    | '/resultsTable'
    | '/todo'
    | '/unfinished'
    | '/users'
    | '/admin/articles'
    | '/admin/maintenance'
    | '/admin/methodViewer'
    | '/admin/productViewer'
    | '/competence/competences'
    | '/competence/editRoles'
    | '/competence/examination'
    | '/competence/general'
    | '/competence/myExamination'
    | '/cultivation/fetch'
    | '/cultivation/start'
    | '/customer/customers'
    | '/customer/duplicates'
    | '/disposal/check'
    | '/disposal/dispose'
    | '/elisa/check'
    | '/elisa/mapplates'
    | '/elisa/status'
    | '/elisa/upload'
    | '/feed/check'
    | '/feed/lists'
    | '/feed/read'
    | '/feed/send'
    | '/feed/upload'
    | '/feed/vallprognos'
    | '/invoice/invoice'
    | '/invoice/invoiceGod'
    | '/lungmask/fetch'
    | '/lungmask/start'
    | '/pcr/check'
    | '/pcr/mapplates'
    | '/pcr/pipette'
    | '/pcr/prepare'
    | '/pcr/status'
    | '/pcr/upload'
    | '/registration/$journalId'
    | '/statistics/dayStatistics'
    | '/statistics/statistics'
    | '/trikin/bubble'
    | '/trikin/notes'
    | '/trikin/read'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin'
    | '/competence'
    | '/cultivation'
    | '/customer'
    | '/disposal'
    | '/elisa'
    | '/feed'
    | '/invoice'
    | '/lungmask'
    | '/pcr'
    | '/statistics'
    | '/trikin'
    | '/dashboard'
    | '/email'
    | '/lineCheck'
    | '/quickRegistration'
    | '/read'
    | '/registration'
    | '/results'
    | '/resultsTable'
    | '/todo'
    | '/unfinished'
    | '/users'
    | '/admin/articles'
    | '/admin/maintenance'
    | '/admin/methodViewer'
    | '/admin/productViewer'
    | '/competence/competences'
    | '/competence/editRoles'
    | '/competence/examination'
    | '/competence/general'
    | '/competence/myExamination'
    | '/cultivation/fetch'
    | '/cultivation/start'
    | '/customer/customers'
    | '/customer/duplicates'
    | '/disposal/check'
    | '/disposal/dispose'
    | '/elisa/check'
    | '/elisa/mapplates'
    | '/elisa/status'
    | '/elisa/upload'
    | '/feed/check'
    | '/feed/lists'
    | '/feed/read'
    | '/feed/send'
    | '/feed/upload'
    | '/feed/vallprognos'
    | '/invoice/invoice'
    | '/invoice/invoiceGod'
    | '/lungmask/fetch'
    | '/lungmask/start'
    | '/pcr/check'
    | '/pcr/mapplates'
    | '/pcr/pipette'
    | '/pcr/prepare'
    | '/pcr/status'
    | '/pcr/upload'
    | '/registration/$journalId'
    | '/statistics/dayStatistics'
    | '/statistics/statistics'
    | '/trikin/bubble'
    | '/trikin/notes'
    | '/trikin/read'
  id:
    | '__root__'
    | '/admin'
    | '/competence'
    | '/cultivation'
    | '/customer'
    | '/disposal'
    | '/elisa'
    | '/feed'
    | '/invoice'
    | '/lungmask'
    | '/pcr'
    | '/statistics'
    | '/trikin'
    | '/dashboard'
    | '/email'
    | '/lineCheck'
    | '/quickRegistration'
    | '/read'
    | '/registration'
    | '/results'
    | '/resultsTable'
    | '/todo'
    | '/unfinished'
    | '/users'
    | '/admin/articles'
    | '/admin/maintenance'
    | '/admin/methodViewer'
    | '/admin/productViewer'
    | '/competence/competences'
    | '/competence/editRoles'
    | '/competence/examination'
    | '/competence/general'
    | '/competence/myExamination'
    | '/cultivation/fetch'
    | '/cultivation/start'
    | '/customer/customers'
    | '/customer/duplicates'
    | '/disposal/check'
    | '/disposal/dispose'
    | '/elisa/check'
    | '/elisa/mapplates'
    | '/elisa/status'
    | '/elisa/upload'
    | '/feed/check'
    | '/feed/lists'
    | '/feed/read'
    | '/feed/send'
    | '/feed/upload'
    | '/feed/vallprognos'
    | '/invoice/invoice'
    | '/invoice/invoiceGod'
    | '/lungmask/fetch'
    | '/lungmask/start'
    | '/pcr/check'
    | '/pcr/mapplates'
    | '/pcr/pipette'
    | '/pcr/prepare'
    | '/pcr/status'
    | '/pcr/upload'
    | '/registration/$journalId'
    | '/statistics/dayStatistics'
    | '/statistics/statistics'
    | '/trikin/bubble'
    | '/trikin/notes'
    | '/trikin/read'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  CompetenceRouteRoute: typeof CompetenceRouteRouteWithChildren
  CultivationRouteRoute: typeof CultivationRouteRouteWithChildren
  CustomerRouteRoute: typeof CustomerRouteRouteWithChildren
  DisposalRouteRoute: typeof DisposalRouteRouteWithChildren
  ElisaRouteRoute: typeof ElisaRouteRouteWithChildren
  FeedRouteRoute: typeof FeedRouteRouteWithChildren
  InvoiceRouteRoute: typeof InvoiceRouteRouteWithChildren
  LungmaskRouteRoute: typeof LungmaskRouteRouteWithChildren
  PcrRouteRoute: typeof PcrRouteRouteWithChildren
  StatisticsRouteRoute: typeof StatisticsRouteRouteWithChildren
  TrikinRouteRoute: typeof TrikinRouteRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  EmailRoute: typeof EmailRoute
  LineCheckRoute: typeof LineCheckRoute
  QuickRegistrationRoute: typeof QuickRegistrationRoute
  ReadRoute: typeof ReadRoute
  RegistrationRoute: typeof RegistrationRouteWithChildren
  ResultsRoute: typeof ResultsRoute
  ResultsTableRoute: typeof ResultsTableRoute
  TodoRoute: typeof TodoRoute
  UnfinishedRoute: typeof UnfinishedRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competence': {
      id: '/competence'
      path: '/competence'
      fullPath: '/competence'
      preLoaderRoute: typeof CompetenceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cultivation': {
      id: '/cultivation'
      path: '/cultivation'
      fullPath: '/cultivation'
      preLoaderRoute: typeof CultivationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer': {
      id: '/customer'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof CustomerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disposal': {
      id: '/disposal'
      path: '/disposal'
      fullPath: '/disposal'
      preLoaderRoute: typeof DisposalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/elisa': {
      id: '/elisa'
      path: '/elisa'
      fullPath: '/elisa'
      preLoaderRoute: typeof ElisaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email': {
      id: '/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof EmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoice': {
      id: '/invoice'
      path: '/invoice'
      fullPath: '/invoice'
      preLoaderRoute: typeof InvoiceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lineCheck': {
      id: '/lineCheck'
      path: '/lineCheck'
      fullPath: '/lineCheck'
      preLoaderRoute: typeof LineCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lungmask': {
      id: '/lungmask'
      path: '/lungmask'
      fullPath: '/lungmask'
      preLoaderRoute: typeof LungmaskRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pcr': {
      id: '/pcr'
      path: '/pcr'
      fullPath: '/pcr'
      preLoaderRoute: typeof PcrRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quickRegistration': {
      id: '/quickRegistration'
      path: '/quickRegistration'
      fullPath: '/quickRegistration'
      preLoaderRoute: typeof QuickRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read': {
      id: '/read'
      path: '/read'
      fullPath: '/read'
      preLoaderRoute: typeof ReadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration': {
      id: '/registration'
      path: '/registration'
      fullPath: '/registration'
      preLoaderRoute: typeof RegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resultsTable': {
      id: '/resultsTable'
      path: '/resultsTable'
      fullPath: '/resultsTable'
      preLoaderRoute: typeof ResultsTableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/statistics': {
      id: '/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof StatisticsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/todo': {
      id: '/todo'
      path: '/todo'
      fullPath: '/todo'
      preLoaderRoute: typeof TodoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trikin': {
      id: '/trikin'
      path: '/trikin'
      fullPath: '/trikin'
      preLoaderRoute: typeof TrikinRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unfinished': {
      id: '/unfinished'
      path: '/unfinished'
      fullPath: '/unfinished'
      preLoaderRoute: typeof UnfinishedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/articles': {
      id: '/admin/articles'
      path: '/articles'
      fullPath: '/admin/articles'
      preLoaderRoute: typeof AdminArticlesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/maintenance': {
      id: '/admin/maintenance'
      path: '/maintenance'
      fullPath: '/admin/maintenance'
      preLoaderRoute: typeof AdminMaintenanceRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/methodViewer': {
      id: '/admin/methodViewer'
      path: '/methodViewer'
      fullPath: '/admin/methodViewer'
      preLoaderRoute: typeof AdminMethodViewerRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/productViewer': {
      id: '/admin/productViewer'
      path: '/productViewer'
      fullPath: '/admin/productViewer'
      preLoaderRoute: typeof AdminProductViewerRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/competence/competences': {
      id: '/competence/competences'
      path: '/competences'
      fullPath: '/competence/competences'
      preLoaderRoute: typeof CompetenceCompetencesRouteImport
      parentRoute: typeof CompetenceRouteRoute
    }
    '/competence/editRoles': {
      id: '/competence/editRoles'
      path: '/editRoles'
      fullPath: '/competence/editRoles'
      preLoaderRoute: typeof CompetenceEditRolesRouteImport
      parentRoute: typeof CompetenceRouteRoute
    }
    '/competence/examination': {
      id: '/competence/examination'
      path: '/examination'
      fullPath: '/competence/examination'
      preLoaderRoute: typeof CompetenceExaminationRouteImport
      parentRoute: typeof CompetenceRouteRoute
    }
    '/competence/general': {
      id: '/competence/general'
      path: '/general'
      fullPath: '/competence/general'
      preLoaderRoute: typeof CompetenceGeneralRouteImport
      parentRoute: typeof CompetenceRouteRoute
    }
    '/competence/myExamination': {
      id: '/competence/myExamination'
      path: '/myExamination'
      fullPath: '/competence/myExamination'
      preLoaderRoute: typeof CompetenceMyExaminationRouteImport
      parentRoute: typeof CompetenceRouteRoute
    }
    '/cultivation/fetch': {
      id: '/cultivation/fetch'
      path: '/fetch'
      fullPath: '/cultivation/fetch'
      preLoaderRoute: typeof CultivationFetchRouteImport
      parentRoute: typeof CultivationRouteRoute
    }
    '/cultivation/start': {
      id: '/cultivation/start'
      path: '/start'
      fullPath: '/cultivation/start'
      preLoaderRoute: typeof CultivationStartRouteImport
      parentRoute: typeof CultivationRouteRoute
    }
    '/customer/customers': {
      id: '/customer/customers'
      path: '/customers'
      fullPath: '/customer/customers'
      preLoaderRoute: typeof CustomerCustomersRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/customer/duplicates': {
      id: '/customer/duplicates'
      path: '/duplicates'
      fullPath: '/customer/duplicates'
      preLoaderRoute: typeof CustomerDuplicatesRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/disposal/check': {
      id: '/disposal/check'
      path: '/check'
      fullPath: '/disposal/check'
      preLoaderRoute: typeof DisposalCheckRouteImport
      parentRoute: typeof DisposalRouteRoute
    }
    '/disposal/dispose': {
      id: '/disposal/dispose'
      path: '/dispose'
      fullPath: '/disposal/dispose'
      preLoaderRoute: typeof DisposalDisposeRouteImport
      parentRoute: typeof DisposalRouteRoute
    }
    '/elisa/check': {
      id: '/elisa/check'
      path: '/check'
      fullPath: '/elisa/check'
      preLoaderRoute: typeof ElisaCheckRouteImport
      parentRoute: typeof ElisaRouteRoute
    }
    '/elisa/mapplates': {
      id: '/elisa/mapplates'
      path: '/mapplates'
      fullPath: '/elisa/mapplates'
      preLoaderRoute: typeof ElisaMapplatesRouteImport
      parentRoute: typeof ElisaRouteRoute
    }
    '/elisa/status': {
      id: '/elisa/status'
      path: '/status'
      fullPath: '/elisa/status'
      preLoaderRoute: typeof ElisaStatusRouteImport
      parentRoute: typeof ElisaRouteRoute
    }
    '/elisa/upload': {
      id: '/elisa/upload'
      path: '/upload'
      fullPath: '/elisa/upload'
      preLoaderRoute: typeof ElisaUploadRouteImport
      parentRoute: typeof ElisaRouteRoute
    }
    '/feed/check': {
      id: '/feed/check'
      path: '/check'
      fullPath: '/feed/check'
      preLoaderRoute: typeof FeedCheckRouteImport
      parentRoute: typeof FeedRouteRoute
    }
    '/feed/lists': {
      id: '/feed/lists'
      path: '/lists'
      fullPath: '/feed/lists'
      preLoaderRoute: typeof FeedListsRouteImport
      parentRoute: typeof FeedRouteRoute
    }
    '/feed/read': {
      id: '/feed/read'
      path: '/read'
      fullPath: '/feed/read'
      preLoaderRoute: typeof FeedReadRouteImport
      parentRoute: typeof FeedRouteRoute
    }
    '/feed/send': {
      id: '/feed/send'
      path: '/send'
      fullPath: '/feed/send'
      preLoaderRoute: typeof FeedSendRouteImport
      parentRoute: typeof FeedRouteRoute
    }
    '/feed/upload': {
      id: '/feed/upload'
      path: '/upload'
      fullPath: '/feed/upload'
      preLoaderRoute: typeof FeedUploadRouteImport
      parentRoute: typeof FeedRouteRoute
    }
    '/feed/vallprognos': {
      id: '/feed/vallprognos'
      path: '/vallprognos'
      fullPath: '/feed/vallprognos'
      preLoaderRoute: typeof FeedVallprognosRouteImport
      parentRoute: typeof FeedRouteRoute
    }
    '/invoice/invoice': {
      id: '/invoice/invoice'
      path: '/invoice'
      fullPath: '/invoice/invoice'
      preLoaderRoute: typeof InvoiceInvoiceRouteImport
      parentRoute: typeof InvoiceRouteRoute
    }
    '/invoice/invoiceGod': {
      id: '/invoice/invoiceGod'
      path: '/invoiceGod'
      fullPath: '/invoice/invoiceGod'
      preLoaderRoute: typeof InvoiceInvoiceGodRouteImport
      parentRoute: typeof InvoiceRouteRoute
    }
    '/lungmask/fetch': {
      id: '/lungmask/fetch'
      path: '/fetch'
      fullPath: '/lungmask/fetch'
      preLoaderRoute: typeof LungmaskFetchRouteImport
      parentRoute: typeof LungmaskRouteRoute
    }
    '/lungmask/start': {
      id: '/lungmask/start'
      path: '/start'
      fullPath: '/lungmask/start'
      preLoaderRoute: typeof LungmaskStartRouteImport
      parentRoute: typeof LungmaskRouteRoute
    }
    '/pcr/check': {
      id: '/pcr/check'
      path: '/check'
      fullPath: '/pcr/check'
      preLoaderRoute: typeof PcrCheckRouteImport
      parentRoute: typeof PcrRouteRoute
    }
    '/pcr/mapplates': {
      id: '/pcr/mapplates'
      path: '/mapplates'
      fullPath: '/pcr/mapplates'
      preLoaderRoute: typeof PcrMapplatesRouteImport
      parentRoute: typeof PcrRouteRoute
    }
    '/pcr/pipette': {
      id: '/pcr/pipette'
      path: '/pipette'
      fullPath: '/pcr/pipette'
      preLoaderRoute: typeof PcrPipetteRouteImport
      parentRoute: typeof PcrRouteRoute
    }
    '/pcr/prepare': {
      id: '/pcr/prepare'
      path: '/prepare'
      fullPath: '/pcr/prepare'
      preLoaderRoute: typeof PcrPrepareRouteImport
      parentRoute: typeof PcrRouteRoute
    }
    '/pcr/status': {
      id: '/pcr/status'
      path: '/status'
      fullPath: '/pcr/status'
      preLoaderRoute: typeof PcrStatusRouteImport
      parentRoute: typeof PcrRouteRoute
    }
    '/pcr/upload': {
      id: '/pcr/upload'
      path: '/upload'
      fullPath: '/pcr/upload'
      preLoaderRoute: typeof PcrUploadRouteImport
      parentRoute: typeof PcrRouteRoute
    }
    '/registration/$journalId': {
      id: '/registration/$journalId'
      path: '/$journalId'
      fullPath: '/registration/$journalId'
      preLoaderRoute: typeof RegistrationJournalIdRouteImport
      parentRoute: typeof RegistrationRoute
    }
    '/statistics/dayStatistics': {
      id: '/statistics/dayStatistics'
      path: '/dayStatistics'
      fullPath: '/statistics/dayStatistics'
      preLoaderRoute: typeof StatisticsDayStatisticsRouteImport
      parentRoute: typeof StatisticsRouteRoute
    }
    '/statistics/statistics': {
      id: '/statistics/statistics'
      path: '/statistics'
      fullPath: '/statistics/statistics'
      preLoaderRoute: typeof StatisticsStatisticsRouteImport
      parentRoute: typeof StatisticsRouteRoute
    }
    '/trikin/bubble': {
      id: '/trikin/bubble'
      path: '/bubble'
      fullPath: '/trikin/bubble'
      preLoaderRoute: typeof TrikinBubbleRouteImport
      parentRoute: typeof TrikinRouteRoute
    }
    '/trikin/notes': {
      id: '/trikin/notes'
      path: '/notes'
      fullPath: '/trikin/notes'
      preLoaderRoute: typeof TrikinNotesRouteImport
      parentRoute: typeof TrikinRouteRoute
    }
    '/trikin/read': {
      id: '/trikin/read'
      path: '/read'
      fullPath: '/trikin/read'
      preLoaderRoute: typeof TrikinReadRouteImport
      parentRoute: typeof TrikinRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminArticlesRoute: typeof AdminArticlesRoute
  AdminMaintenanceRoute: typeof AdminMaintenanceRoute
  AdminMethodViewerRoute: typeof AdminMethodViewerRoute
  AdminProductViewerRoute: typeof AdminProductViewerRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminArticlesRoute: AdminArticlesRoute,
  AdminMaintenanceRoute: AdminMaintenanceRoute,
  AdminMethodViewerRoute: AdminMethodViewerRoute,
  AdminProductViewerRoute: AdminProductViewerRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface CompetenceRouteRouteChildren {
  CompetenceCompetencesRoute: typeof CompetenceCompetencesRoute
  CompetenceEditRolesRoute: typeof CompetenceEditRolesRoute
  CompetenceExaminationRoute: typeof CompetenceExaminationRoute
  CompetenceGeneralRoute: typeof CompetenceGeneralRoute
  CompetenceMyExaminationRoute: typeof CompetenceMyExaminationRoute
}

const CompetenceRouteRouteChildren: CompetenceRouteRouteChildren = {
  CompetenceCompetencesRoute: CompetenceCompetencesRoute,
  CompetenceEditRolesRoute: CompetenceEditRolesRoute,
  CompetenceExaminationRoute: CompetenceExaminationRoute,
  CompetenceGeneralRoute: CompetenceGeneralRoute,
  CompetenceMyExaminationRoute: CompetenceMyExaminationRoute,
}

const CompetenceRouteRouteWithChildren = CompetenceRouteRoute._addFileChildren(
  CompetenceRouteRouteChildren,
)

interface CultivationRouteRouteChildren {
  CultivationFetchRoute: typeof CultivationFetchRoute
  CultivationStartRoute: typeof CultivationStartRoute
}

const CultivationRouteRouteChildren: CultivationRouteRouteChildren = {
  CultivationFetchRoute: CultivationFetchRoute,
  CultivationStartRoute: CultivationStartRoute,
}

const CultivationRouteRouteWithChildren =
  CultivationRouteRoute._addFileChildren(CultivationRouteRouteChildren)

interface CustomerRouteRouteChildren {
  CustomerCustomersRoute: typeof CustomerCustomersRoute
  CustomerDuplicatesRoute: typeof CustomerDuplicatesRoute
}

const CustomerRouteRouteChildren: CustomerRouteRouteChildren = {
  CustomerCustomersRoute: CustomerCustomersRoute,
  CustomerDuplicatesRoute: CustomerDuplicatesRoute,
}

const CustomerRouteRouteWithChildren = CustomerRouteRoute._addFileChildren(
  CustomerRouteRouteChildren,
)

interface DisposalRouteRouteChildren {
  DisposalCheckRoute: typeof DisposalCheckRoute
  DisposalDisposeRoute: typeof DisposalDisposeRoute
}

const DisposalRouteRouteChildren: DisposalRouteRouteChildren = {
  DisposalCheckRoute: DisposalCheckRoute,
  DisposalDisposeRoute: DisposalDisposeRoute,
}

const DisposalRouteRouteWithChildren = DisposalRouteRoute._addFileChildren(
  DisposalRouteRouteChildren,
)

interface ElisaRouteRouteChildren {
  ElisaCheckRoute: typeof ElisaCheckRoute
  ElisaMapplatesRoute: typeof ElisaMapplatesRoute
  ElisaStatusRoute: typeof ElisaStatusRoute
  ElisaUploadRoute: typeof ElisaUploadRoute
}

const ElisaRouteRouteChildren: ElisaRouteRouteChildren = {
  ElisaCheckRoute: ElisaCheckRoute,
  ElisaMapplatesRoute: ElisaMapplatesRoute,
  ElisaStatusRoute: ElisaStatusRoute,
  ElisaUploadRoute: ElisaUploadRoute,
}

const ElisaRouteRouteWithChildren = ElisaRouteRoute._addFileChildren(
  ElisaRouteRouteChildren,
)

interface FeedRouteRouteChildren {
  FeedCheckRoute: typeof FeedCheckRoute
  FeedListsRoute: typeof FeedListsRoute
  FeedReadRoute: typeof FeedReadRoute
  FeedSendRoute: typeof FeedSendRoute
  FeedUploadRoute: typeof FeedUploadRoute
  FeedVallprognosRoute: typeof FeedVallprognosRoute
}

const FeedRouteRouteChildren: FeedRouteRouteChildren = {
  FeedCheckRoute: FeedCheckRoute,
  FeedListsRoute: FeedListsRoute,
  FeedReadRoute: FeedReadRoute,
  FeedSendRoute: FeedSendRoute,
  FeedUploadRoute: FeedUploadRoute,
  FeedVallprognosRoute: FeedVallprognosRoute,
}

const FeedRouteRouteWithChildren = FeedRouteRoute._addFileChildren(
  FeedRouteRouteChildren,
)

interface InvoiceRouteRouteChildren {
  InvoiceInvoiceRoute: typeof InvoiceInvoiceRoute
  InvoiceInvoiceGodRoute: typeof InvoiceInvoiceGodRoute
}

const InvoiceRouteRouteChildren: InvoiceRouteRouteChildren = {
  InvoiceInvoiceRoute: InvoiceInvoiceRoute,
  InvoiceInvoiceGodRoute: InvoiceInvoiceGodRoute,
}

const InvoiceRouteRouteWithChildren = InvoiceRouteRoute._addFileChildren(
  InvoiceRouteRouteChildren,
)

interface LungmaskRouteRouteChildren {
  LungmaskFetchRoute: typeof LungmaskFetchRoute
  LungmaskStartRoute: typeof LungmaskStartRoute
}

const LungmaskRouteRouteChildren: LungmaskRouteRouteChildren = {
  LungmaskFetchRoute: LungmaskFetchRoute,
  LungmaskStartRoute: LungmaskStartRoute,
}

const LungmaskRouteRouteWithChildren = LungmaskRouteRoute._addFileChildren(
  LungmaskRouteRouteChildren,
)

interface PcrRouteRouteChildren {
  PcrCheckRoute: typeof PcrCheckRoute
  PcrMapplatesRoute: typeof PcrMapplatesRoute
  PcrPipetteRoute: typeof PcrPipetteRoute
  PcrPrepareRoute: typeof PcrPrepareRoute
  PcrStatusRoute: typeof PcrStatusRoute
  PcrUploadRoute: typeof PcrUploadRoute
}

const PcrRouteRouteChildren: PcrRouteRouteChildren = {
  PcrCheckRoute: PcrCheckRoute,
  PcrMapplatesRoute: PcrMapplatesRoute,
  PcrPipetteRoute: PcrPipetteRoute,
  PcrPrepareRoute: PcrPrepareRoute,
  PcrStatusRoute: PcrStatusRoute,
  PcrUploadRoute: PcrUploadRoute,
}

const PcrRouteRouteWithChildren = PcrRouteRoute._addFileChildren(
  PcrRouteRouteChildren,
)

interface StatisticsRouteRouteChildren {
  StatisticsDayStatisticsRoute: typeof StatisticsDayStatisticsRoute
  StatisticsStatisticsRoute: typeof StatisticsStatisticsRoute
}

const StatisticsRouteRouteChildren: StatisticsRouteRouteChildren = {
  StatisticsDayStatisticsRoute: StatisticsDayStatisticsRoute,
  StatisticsStatisticsRoute: StatisticsStatisticsRoute,
}

const StatisticsRouteRouteWithChildren = StatisticsRouteRoute._addFileChildren(
  StatisticsRouteRouteChildren,
)

interface TrikinRouteRouteChildren {
  TrikinBubbleRoute: typeof TrikinBubbleRoute
  TrikinNotesRoute: typeof TrikinNotesRoute
  TrikinReadRoute: typeof TrikinReadRoute
}

const TrikinRouteRouteChildren: TrikinRouteRouteChildren = {
  TrikinBubbleRoute: TrikinBubbleRoute,
  TrikinNotesRoute: TrikinNotesRoute,
  TrikinReadRoute: TrikinReadRoute,
}

const TrikinRouteRouteWithChildren = TrikinRouteRoute._addFileChildren(
  TrikinRouteRouteChildren,
)

interface RegistrationRouteChildren {
  RegistrationJournalIdRoute: typeof RegistrationJournalIdRoute
}

const RegistrationRouteChildren: RegistrationRouteChildren = {
  RegistrationJournalIdRoute: RegistrationJournalIdRoute,
}

const RegistrationRouteWithChildren = RegistrationRoute._addFileChildren(
  RegistrationRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AdminRouteRoute: AdminRouteRouteWithChildren,
  CompetenceRouteRoute: CompetenceRouteRouteWithChildren,
  CultivationRouteRoute: CultivationRouteRouteWithChildren,
  CustomerRouteRoute: CustomerRouteRouteWithChildren,
  DisposalRouteRoute: DisposalRouteRouteWithChildren,
  ElisaRouteRoute: ElisaRouteRouteWithChildren,
  FeedRouteRoute: FeedRouteRouteWithChildren,
  InvoiceRouteRoute: InvoiceRouteRouteWithChildren,
  LungmaskRouteRoute: LungmaskRouteRouteWithChildren,
  PcrRouteRoute: PcrRouteRouteWithChildren,
  StatisticsRouteRoute: StatisticsRouteRouteWithChildren,
  TrikinRouteRoute: TrikinRouteRouteWithChildren,
  DashboardRoute: DashboardRoute,
  EmailRoute: EmailRoute,
  LineCheckRoute: LineCheckRoute,
  QuickRegistrationRoute: QuickRegistrationRoute,
  ReadRoute: ReadRoute,
  RegistrationRoute: RegistrationRouteWithChildren,
  ResultsRoute: ResultsRoute,
  ResultsTableRoute: ResultsTableRoute,
  TodoRoute: TodoRoute,
  UnfinishedRoute: UnfinishedRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
